// Ce fichier est généré automatiquement par scripts/generate-modules-index.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:modules-index

/**
 * Index central des modules
 *
 * Ce fichier importe explicitement tous les modules pour garantir
 * leur chargement en production, notamment dans un contexte d'iframe.
 *
 * IMPORTANT: Lors de l'ajout d'un nouveau module, il doit avoir
 * un fichier index.ts et sera automatiquement détecté par le script.
 */

// ================================
// IMPORTS DES MODULES
// ================================
import abonnementModule from "./abonnement/index"
import alarmesV2Module from "./alarmes-v2/index"
import courtageModule from "./courtage/index"
import dataModule from "./data/index"
import energyManagerModule from "./energy-manager/index"
import espaceEntrepriseModule from "./espace-entreprise/index"
import homeModule from "./home/index"
import irveModule from "./irve/index"
import pvModule from "./pv/index"
import usageProfileModule from "./usage-profile/index"

// ================================
// EXPORT DES MODULES
// ================================
export const modules = [
    abonnementModule,
    alarmesV2Module,
    courtageModule,
    dataModule,
    energyManagerModule,
    espaceEntrepriseModule,
    homeModule,
    irveModule,
    pvModule,
    usageProfileModule,
] as const
